module.exports = __webpack_public_path__ + "img/09.b245ce8d.jpg";